const styles = theme => ({
  root: {
    position: 'relative',
    minHeight: theme.spacing(10),
    width: '100%',
  },
  paper: {
    display: 'block',
    width: '100%',
    height: '100%',
    padding: theme.spacing(2),
    cursor: 'pointer',
  },
  radio: {
    position: 'absolute',
    top: theme.spacing(1) / 2,
    left: theme.spacing(1) / 2,
    '&.Mui-checked + label': {
      borderColor: theme.palette.secondary.main,
    },
  },
})

export default styles
